(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('productionRoutingWork', {
        templateUrl: 'views/components/views/productionRoutingWork/productionRoutingWork.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'productionRoutingWorkService', 'labourPositionService', 'logisticService', 'equipmentEditService', 'operationFactoryService', 'operationService', 'rememberService', function ($stateParams, stateService, utilityService, translateService, modalService, productionRoutingWorkService, labourPositionService, logisticService, equipmentEditService, operationFactoryService, operationService, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let productionRoutingworkKeyno = $stateParams.productionroutingwork_keyno;
            let productionRoutingKeyno = $stateParams.productionrouting_keyno;

            let variableNames = {
                factory_id: ''
            };

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                factoryButtons: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('factories') },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('factorymenu', { factory_id: vm.model.edit.factory_id }) }
                ],
                operationButtons: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('operations') },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('operationmenu', { operation_id: vm.model.edit.operation_id }) }
                ],
                workGroupButtons: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('workgrps') }
                ],
                workGroupButtonsExpanded: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('workgrp_keyno') },
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('workgrps') },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('workgrpmenu', { workgrp_keyno: vm.model.edit.workgrp_keyno }) }
                ],
                equipmentButtons: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('equipments') }
                ],
                equipmentButtonsExpanded: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('equipment_id') },
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('equipments') },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('equipmentedit', { equipment_id: vm.model.edit.equipment_id }) }
                ],
                edit: {},
                selectListFactories: [],
                selectListOperations: [],
                selectListWorkGroups: [],
                selectListEquipments: [],
                lockedSave: false,
                lockedDelete: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadEdit() {
                vm.model.edit = (await productionRoutingWorkService.getEdit({
                    productionroutingwork_keyno: productionRoutingworkKeyno,
                    productionrouting_keyno: productionRoutingKeyno
                }))[0];

                Promise.all([
                    loadSelectFactories(),
                    loadOperations(),
                    loadSelectWorkGroups(),
                    loadSelectEquipments()
                ]).then(() => Promise.resolve());
            }

            async function loadSelectFactories() {
                vm.model.selectListFactories = await labourPositionService.listSelectFactories();
            }

            async function loadOperations() {
                if (utilityService.validateParmsValue(vm.model.edit.factory_id) !== true) return;

                vm.model.selectListOperations = await logisticService.listOperations(vm.model.edit);
            }

            async function loadSelectWorkGroups() {
                if (utilityService.validateParmsValue(vm.model.edit.factory_id) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.operation_id) !== true) return;

                vm.model.selectListWorkGroups = await equipmentEditService.listSelectWorkGroups(vm.model.edit);
            }

            async function loadSelectEquipments() {
                if (utilityService.validateParmsValue(vm.model.edit.factory_id) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.operation_id) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.workgrp_keyno, true) !== true) return;

                vm.model.selectListEquipments = await operationFactoryService.listSelectEquipments(vm.model.edit);
            }

            function retrieveOperation() {
                if (utilityService.validateParmsValue(vm.model.edit.operation_id) !== true) return;

                operationService.getOperation({ operation_id: vm.model.edit.operation_id }).then((response) => vm.model.edit.unit_name = response[0].unit_name);
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                        case '':
                            break;
                        default:
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                            break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'factory_id':
                        if (utilityService.validateParmsValue(vm.model.edit[id]) !== true) return;

                        variableValue = vm.model.edit[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region RESET BUTTON FUNCTION

            function reset(id) {
                switch (id) {
                    case 'workgrp_keyno':
                        vm.model.edit.workgrp_keyno = '0';

                        if (vm.model.edit.workgrp_keyno === '0') loadSelectEquipments();
                        break;
                    case 'equipment_id':
                        vm.model.edit.equipment_id = '';
                        break;
                    default:
                        break;
                }
            }

            // #endregion RESET BUTTON FUNCTION

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                productionRoutingWorkService.saveObj(vm.model.edit).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    productionRoutingWorkService.deleteItem(vm.model.edit).then((response) => {
                        if (response[0] && response[0].errorcode !== '0') {
                        	modalService.show({
                        		type: 'warning',
                        		title: translations.error,
                        		message: response[0].errormessage,
                        		buttons: [{
                        			label: translations.ok,
                        			cssClass: 'btn-warning',
                        			action: function (dialogItself) {
                        				dialogItself.close();
                        				vm.model.lockedDelete = false;
                        			}
                        		}]
                        	});
                        } else {
                        	vm.model.lockedDelete = false;
                        	stateService.back();
                        }
                    }, () => {
                        vm.model.lockedDelete = false;
                    });
                }, () => {
                    vm.model.lockedDelete = false;
                });
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'factory_id':
                        if (utilityService.validateWatchValue(value, vm.model.edit.factory_id) !== true) return;

                        vm.model.edit.factory_id = value;

                        if (utilityService.validateParmsValue(vm.model.edit.factory_id) !== true) return;

                        Promise.all([
                            rememberFunc('factory_id')
                        ]).then(() => {
                            loadOperations();
                            loadSelectWorkGroups();
                            loadSelectEquipments();

                            Promise.resolve();
                        });
                        break;
                    case 'operation_id':
                        if (utilityService.validateWatchValue(value, vm.model.edit.operation_id) !== true) return;

                        vm.model.edit.operation_id = value;

                        if (utilityService.validateParmsValue(vm.model.edit.operation_id) !== true) return;

                        loadSelectWorkGroups();
                        loadSelectEquipments();
                        retrieveOperation();
                        break;
                    case 'workgrp_keyno':
                        if (utilityService.validateWatchValue(value, vm.model.edit.workgrp_keyno) !== true) return;

                        vm.model.edit.workgrp_keyno = value;

                        if (utilityService.validateParmsValue(vm.model.edit.workgrp_keyno, true) !== true) return;

                        loadSelectEquipments();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
            	loadEdit();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
